import {type DispatchActionType} from '../models/DispatchActionType';
import {type IState} from '../models/IState';
import {type DispatchAction} from '../store';

// Default state data. Required for reducers to work correctly right away.
export const initialState: IState = {
	environment: {
		language: 'en-US',
		translated_modal_terms: {},
		plugin: {
			version: '',
			mode: 'live',
			pageType: 'cart',
			buttonColor: '#21105d',
			featureSupport: {},
		},
		customer: {
			mobile: false,
			saveToBrowserSelected: true,
		},
		modalUI: {
			open: false,
			page: 'info',
			loadingMode: 'finished',
			requestedPage: undefined,
		},
	},
	peachPayOrder: {
		sessionId: '',
		customerAddressValidated: false,
		additionalFields: {},
		errorMessage: '',
	},
	peachPayCustomer: {
		version: 2,
		form_fields: {
			shipping_company: '',
			shipping_email: '',
			shipping_first_name: '',
			shipping_last_name: '',
			shipping_address_1: '',
			shipping_address_2: '',
			shipping_city: '',
			shipping_state: '',
			shipping_country: '',
			shipping_postcode: '',
			shipping_phone: '',
			billing_company: '',
			billing_email: '',
			billing_first_name: '',
			billing_last_name: '',
			billing_address_1: '',
			billing_address_2: '',
			billing_city: '',
			billing_state: '',
			billing_country: '',
			billing_postcode: '',
			billing_phone: '',
		},
	},
	merchantConfiguration: {
		id: '',
		name: '',
		hostName: '',
		general: {
			currency: {
				name: 'United States Dollar',
				code: 'USD',
				symbol: '$',
				position: 'left',
				thousands_separator: ',',
				decimal_separator: '.',
				rounding: 'disabled',
				number_of_decimals: 2,
				hidden: false,
			},
		},
		shipping: {
			shippingZones: 0,
		},
		tax: {
			displayPricesInCartAndCheckout: 'excludeTax',
		},
	},
	calculatedCarts: {
		// Standard/Default cart is always the key "0"
		0: {
			package_record: {},
			cart: [],
			summary: {
				fees_record: {},
				coupons_record: {},
				gift_card_record: {},
				subtotal: 0,
				total_shipping: 0,
				tax_lines: [],
				total_tax: 0,
				total: 0,
			},
			cart_meta: {
				is_virtual: false,
			},
		},
	},
	paymentConfiguration: {
		selectedGateway: '',
		availableGateways: [],
		gatewayAvailabilityDetails: {},

		gatewayConfigurations: {},
	},
};

export function createStaticDispatchUpdate<T>(type: DispatchActionType, payload: T): () => DispatchAction<T> {
	return () => ({
		type,
		payload,
	});
}

/**
 * Returns a action creator to return a specific type of Dispatch Action without processing.
 */
export function createDispatchUpdate<T>(type: DispatchActionType): (payload: T) => DispatchAction<T> {
	return (payload: T) => ({
		type,
		payload,
	});
}

/**
 * Returns a action creator to return a specific type of dispatch action with some processing of the inputed
 */
export function createCustomDispatchUpdate<I, T>(type: DispatchActionType, transformer: (input: I) => T): (payload: I) => DispatchAction<T> {
	return (input: I) => {
		const payload = transformer(input);
		return {
			type,
			payload,
		};
	};
}
